import React, { ReactNode } from "react";
import Container from "@/src/components/Container/Container";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import TextContainer from "@/src/components/Container/TextContainer";
import Grid from "@mui/material/Grid";
import GradientPaper from "@/src/components/GradientComponents/GradientPaper";
import howItWorksSectionStyle from "./howItWorksSectionBaseStyle";
import { useTheme } from "@mui/material/styles";
import IconWrapper from "@/src/components/IconWrapper/IconWrapper";

type HowItWorksSectionBaseProps = {
  sections: {
    title: string;
    description: ReactNode;
    icon: React.ElementType;
  }[];
};

const HowItWorksSectionBase = ({ sections }: HowItWorksSectionBaseProps) => {
  const theme = useTheme();

  return (
    <>
      <Container sx={howItWorksSectionStyle.centered}>
        <Box id="so-funktioniert-es" />
        <Typography variant="h3" component="h2">So einfach funktioniert es</Typography>
      </Container>
      <TextContainer sx={howItWorksSectionStyle.centered}>
        <Grid container>
          <Grid size={12}>
            <GradientPaper sx={howItWorksSectionStyle.paper}>
              {sections.map((section, index) => (
                <Grid container key={index} sx={howItWorksSectionStyle.advantageContainer}>
                  {index % 2 === 0 && (
                    <Grid
                      size={{
                        xs: 12,
                        sm: 4
                      }}>
                      <IconWrapper icon={section.icon} sx={howItWorksSectionStyle.icon(theme)} />
                    </Grid>
                  )}

                  <Grid
                    size={{
                      xs: 12,
                      sm: 8
                    }}>
                    <Typography variant="h5" component="h3">{section.title}</Typography>
                    <p>{section.description}</p>
                  </Grid>

                  {index % 2 === 1 && (
                    <Grid
                      sx={howItWorksSectionStyle.gridItemReversed}
                      size={{
                        xs: 12,
                        sm: 4
                      }}>
                      <IconWrapper icon={section.icon} sx={howItWorksSectionStyle.icon(theme)} />
                    </Grid>
                  )}
                </Grid>
              ))}
            </GradientPaper>
          </Grid>
        </Grid>
      </TextContainer>
    </>
  );
};

export default HowItWorksSectionBase;
